import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Calendar from 'react-calendar'
import { Svg } from '../../1_Atoms/Svg/Svg';
import Radio from '../../1_Atoms/Forms/Radio/Radio';
import Button from '../../1_Atoms/Button/Button';
import generalController from '../../../controllers/generalController';
import { languageController } from '../../../controllers/language/languageController';

function DateAndTimeSelector({
  onSubmit,
}) {
  const today = new Date();

  const morningLabel = languageController.getCopy('global', 'morning')
  const afternoonLabel = languageController.getCopy('global', 'afternoon')
  const eveningLabel = languageController.getCopy('global', 'evening')

  const [dateAndTime, setDateAndTime] = useState({
    date: today,
    time: morningLabel,
  })

  return (
    <div className="mz-date-and-time-selector">
      <div className="mz-container">
        <div className="mz-full-width mz-date-and-time-selector__inner">

          <div className="mz-date-and-time-selector__main">
            <div className="mz-date-and-time-selector__calendar">
              <Calendar
                className="mz-calendar"
                calendarType="US"
                defaultValue={today}
                minDate={today}
                maxDate={new Date(new Date().setFullYear(today.getFullYear() + 1))} // one year from now
                minDetail="month"
                nextLabel={<Svg type="chevron_small" size={1.1} colour="grey" />}
                nextAriaLabel="Go to next month"
                prevLabel={<Svg type="chevron_small" size={1.1} colour="grey" rotation="180" />}
                prevAriaLabel="Go to previous month"
                locale={generalController.detectLanguage() === 'fr' ? 'fr-CA' : "en-US"} // en-US or fr-CA
                onClickDay={(value, e) => setDateAndTime({ ...dateAndTime, date: value })}
              />
            </div>
            <div className="mz-date-and-time-selector__form">
              <div className="mz-date-and-time-selector__time">
                <Radio
                  label={morningLabel}
                  name={"morning"}
                  value={morningLabel}
                  checked={(dateAndTime.time === morningLabel)}
                  onChange={(e) => setDateAndTime({ ...dateAndTime, time: e.target.value })}
                />
                <Radio
                  label={afternoonLabel}
                  name={"afternoon"}
                  value={afternoonLabel}
                  checked={(dateAndTime.time === afternoonLabel)}
                  onChange={(e) => setDateAndTime({ ...dateAndTime, time: e.target.value })}
                />
                <Radio
                  label={eveningLabel}
                  name={"evening"}
                  value={eveningLabel}
                  checked={(dateAndTime.time === eveningLabel)}
                  onChange={(e) => setDateAndTime({ ...dateAndTime, time: e.target.value })}
                />
              </div>
              <Button
                label={languageController.getCopy('global', 'continue')}
                className="mz-btn--red mz-date-and-time-selector__submit"
                buttonIcon={<Svg type="chevron_small" size={0.75} colour="white" />}
                buttonIconPosition="right"
                onClick={() => onSubmit(dateAndTime)}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

DateAndTimeSelector.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default DateAndTimeSelector
